@import (reference) '../../../../constants/spacing.module.less';

.stock {
  justify-content: space-between;
  text-align: center;
  gap: @space-8;
}

.progress-bar {
  margin-top: 11px;

  gap: 1px;
  max-height: 8px;
  height: 8px;
  min-width: 72px;
  > * {
    background-color: var(--green-500);
    min-width: 12px;
  }
  &.warning > * {
    background-color: var(--gold-500);
  }
  &.danger > * {
    background-color: var(--red-500);
  }
  .empty {
    background-color: var(--grey-400);
  }
  :first-child {
    border-top-left-radius: 4px 4px;
    border-bottom-left-radius: 4px 4px;
  }
  :last-child {
    border-top-right-radius: 4px 4px;
    border-bottom-right-radius: 4px 4px;
  }
}

.popup-row {
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: @space-16;

  > * {
    font-weight: 700;
    text-wrap: nowrap;
  }

  &.nested-row {
    color: var(--grey-600);
    margin-left: @space-8;

    > * {
      font-weight: 400;
    }
  }
  &.divider {
    border-top: 1px solid var(--grey-300);
    margin-top: @space-4;
    padding-top: @space-8;
  }

  &.below-divider > * {
    font-weight: 400;
  }
}
.popup-content {
  gap: @space-8;
}
